import React from "react";

import beforeAfterImg from "../../../assets/images/Dietplan-updated/Plan Screen Image /03.webp";

import "./WeightJourneySection.css";

const WeightJourneySection = () => {
  return (
    <div className="diet-weight-journey">
      <div className="diet-weight-journey__card" aria-label="Weight loss journey highlight">
        <div className="diet-weight-journey__left">
          <div className="diet-weight-journey__name">Prabjot Singh</div>
          <div className="diet-weight-journey__age">26 years old</div>

          <div className="diet-weight-journey__lostRow">
            <span className="diet-weight-journey__check" aria-hidden="true" />
            <div className="diet-weight-journey__lostText">
              <div className="diet-weight-journey__lostTop">Lost 34 kg</div>
              <div className="diet-weight-journey__lostSub">in 12 months</div>
            </div>
          </div>

          <div className="diet-weight-journey__desc">
            using smart diet tracking
            <br />
            and daily health
            <br />
            monitoring.
          </div>
        </div>

        <div className="diet-weight-journey__right" aria-hidden="true">
          <img className="diet-weight-journey__beforeAfter" src={beforeAfterImg} alt="" loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default WeightJourneySection;

